export const getDestinationTestConnectionResult =
  'getDestinationTestConnectionResult';
export const isDestinationTestConnectionResultSuccessful =
  'isDestinationTestConnectionResultSuccessful';
